import { httpClient } from "../../../lib/http/axios";
import {
  mapNotificationMessagePage,
  mapNotificationMessageReadResult,
  mapNotificationMessageSummary,
  type NotificationMessagePageResponseRaw,
  type NotificationMessageReadResponseRaw,
  type NotificationMessageSummaryResponseRaw,
} from "../api/adapters";
import type {
  NotificationMessageListFilters,
  NotificationMessagePage,
  NotificationMessageReadResult,
  NotificationMessageSummary,
} from "../types";

/** 查询当前登录用户的消息分页。 */
export async function listNotificationMessages(
  filters: NotificationMessageListFilters,
): Promise<NotificationMessagePage> {
  const response = await httpClient.get<NotificationMessagePageResponseRaw>("/notification-center/messages", {
    params: {
      view: filters.view,
      page: filters.page,
      page_size: filters.pageSize,
    },
  });
  return mapNotificationMessagePage(response.data.data);
}

/** 查询当前登录用户的顶栏消息汇总。 */
export async function getNotificationMessageSummary(): Promise<NotificationMessageSummary> {
  const response = await httpClient.get<NotificationMessageSummaryResponseRaw>(
    "/notification-center/messages/summary",
  );
  return mapNotificationMessageSummary(response.data.data);
}

/** 幂等标记当前登录用户的一条消息已读。 */
export async function markNotificationMessageRead(
  messageId: string,
): Promise<NotificationMessageReadResult> {
  const response = await httpClient.post<NotificationMessageReadResponseRaw>(
    `/notification-center/messages/${encodeURIComponent(messageId)}/read`,
    undefined,
  );
  return mapNotificationMessageReadResult(response.data.data);
}
